import React from "react";

export default class Input extends React.Component<Input.Props, Input.State>
{

    ref: React.RefObject<HTMLInputElement>;

    constructor(props: Input.Props)
    {
        super(props);

        this.ref = props.refinput;
    }


    shouldComponentUpdate()
    {
        return false;
    }


    render()
    {
        return (
            <input
                {...this.props}
                ref={this.ref}
            />
        )
    }


}

export namespace Input
{

    export interface Props extends React.InputHTMLAttributes<HTMLInputElement>
    {
        refinput?: React.RefObject<HTMLInputElement>;
        value?: never;
    }

    export interface State
    {

    }

}